module.exports = __webpack_public_path__ + "static/media/6. Sign up page_V6-03.6204f20d.svg";